import { useState, useEffect } from 'react';
import { Event, EventFilter } from '@/types/event';
import eventsData from '@/data/events.json';
import { updateEventsStatus, validateAllEvents } from '@/utils/eventStatus';

export const useEvents = (filter?: EventFilter) => {
  const [events, setEvents] = useState<Event[]>([]);
  const [filteredEvents, setFilteredEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);

        // Validate format của date và time trong tất cả events
        validateAllEvents(eventsData as Event[]);

        // Cập nhật status tự động dựa trên thời gian hiện tại
        const eventsWithUpdatedStatus = updateEventsStatus(eventsData as Event[]);

        setEvents(eventsWithUpdatedStatus);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Có lỗi xảy ra');
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  useEffect(() => {
    if (!filter) {
      setFilteredEvents(events);
      return;
    }

    let filtered = events;

    // Filter theo status
    if (filter.status && filter.status !== 'ALL') {
      filtered = filtered.filter((event) => event.status === filter.status);
    }

    setFilteredEvents(filtered);
  }, [events, filter]);

  return {
    events: filteredEvents,
    allEvents: events,
    loading,
    error,
  };
};
